export const removeEmpty = (arr: string[] = []) => {
  return arr.filter((el) => el);
};

export const stringToArray = (text: string, splitText: string = " ") => {
  return removeEmpty(text.split(splitText));
};
